import { connect } from "react-redux";
import {
  placeForceWithdrawal,
  placeWithdrawal,
  placeMegaForceWithdrawal,
} from "../../orders/actions";

function mapStateToProps(state) {
  return {
    depot: state.depot,
    orders: state.orders.placeWithdrawal,
    forceOrder: state.orders.placeForceWithdrawal,
    megaForceOrder: state.orders.placeMegaForceWithdrawal,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    placeWithdrawal: (
      amount,
      bankAccountId,
      depotId,
      isSalesPerformanceExcluded,
    ) => {
      dispatch(
        placeWithdrawal(
          amount,
          bankAccountId,
          depotId,
          isSalesPerformanceExcluded,
        ),
      );
    },
    placeForceWithdrawal: (
      amount,
      bankAccountId,
      depotId,
      isSalesPerformanceExcluded,
    ) => {
      dispatch(
        placeForceWithdrawal(
          amount,
          bankAccountId,
          depotId,
          isSalesPerformanceExcluded,
        ),
      );
    },
    placeMegaForceWithdrawal: (
      amount,
      bankAccountId,
      depotId,
      isSalesPerformanceExcluded,
    ) => {
      dispatch(
        placeMegaForceWithdrawal(
          amount,
          bankAccountId,
          depotId,
          isSalesPerformanceExcluded,
        ),
      );
    },
  };
}

export const withdrawalConnector = connect(mapStateToProps, mapDispatchToProps);
